export default (data, existRefundData, isDiscontinuation, isSp) => {

  const r = {
    data,
    existRefundData,
    isDiscontinuation,
    isSp
  };
  const init = () => {
    console.log('buildRun', r)
    BuildRefundResultList(r.data.runTable);
    buildRefundStartPos(r.data.runStart);
    buildRunNote(r.data.noteText)

    if (!r.existRefundData) {
      hideRoundRaceHeader();
    }
  }

  // 車番カラーリスト
  const rowColors = [
    '_one', '_two', '_three', '_four', '_five', '_six'
  ]

  // 出走表リストの作成
  const BuildRefundResultList = (data) => {
    const oddsList = document.querySelector('.le-round-odds__list');
    const oddsListItem = oddsList.firstElementChild;

    const fragment = document.createDocumentFragment();
    data.forEach(rowData => {
      const cloneOddsListitem = oddsListItem.cloneNode(true);
      // 車番カラー設定
      cloneOddsListitem.classList.add(rowColors[rowData.bike_no - 1]);

      // 出走取り消しになった選手とそうでない選手の処理を切り替え
      if (rowData.cancel) {
        cloneOddsListitem.classList.add('is-cancel');
        const cancelCell = createCancelCell();
        cloneOddsListitem.appendChild(cancelCell);
        cloneOddsListitem.querySelector('.le-round-odds__pos').textContent = '';
        cloneOddsListitem.querySelector('.le-round-odds__time').textContent = 'ー';
        cloneOddsListitem.querySelector('.le-round-odds__time').classList.add('_cancel')
        cloneOddsListitem.querySelector('.le-round-odds__rank').remove();
        cloneOddsListitem.querySelector('.le-round-odds__odds-num').textContent = 'ー';
        cloneOddsListitem.querySelector('.le-round-odds__odds-num').classList.add('_cancel')
        cloneOddsListitem.querySelector('.le-round-odds__odds-suffix').remove();
        cloneOddsListitem.querySelector('.le-round-odds__rate').remove();
      } else {
        cloneOddsListitem.querySelector('.le-round-odds__pos').textContent = rowData.bike_no;
        cloneOddsListitem.querySelector('.le-round-odds__time').textContent = rowData.tt_time || 'ー';
        cloneOddsListitem.querySelector('.le-round-odds__rank').textContent = `${rowData.tt_rank ? rowData.tt_rank : 'ー'} 位`;
        cloneOddsListitem.querySelector('.le-round-odds__odds-num').textContent = rowData.odds || '-';
        cloneOddsListitem.querySelector('.le-round-odds__rate-num').textContent = rowData.rate || '-';
      }

      // 共通表示内容設定
      cloneOddsListitem.querySelector('.le-round-odds__name').textContent = rowData.name;
      cloneOddsListitem.querySelector('.le-round-odds__personal-age').textContent = rowData.age;
      cloneOddsListitem.querySelector('.le-round-odds__gear').textContent = rowData.gear_rate || 'ー';
      cloneOddsListitem.querySelector('.le-round-odds__result').innerHTML = rowData.past_result || 'ー';
      cloneOddsListitem.querySelector('.le-round-odds__ratio').innerHTML = rowData.ratio || '-';
      cloneOddsListitem.querySelector('.le-round-odds__personal-country').textContent = rowData.country || 'ー';

      // 選手画像設定と画像の読み込みエラー処理
      const panel = cloneOddsListitem.querySelector('.le-round-odds__panel');
      panel.dataset.modalContent = `${panel.dataset.modalContent}${rowData.playerId}`;
      panel.href = `/player/detail/?player_id=${rowData.playerId}`;
      const playerImg = cloneOddsListitem.querySelector('.le-round-odds__panel-img');
      const playerImgPath = `${window.pist6.imgOrigin}/player_card/${rowData.playerId}/1384x1840.jpg`;
      playerImg.onerror = () => {
        playerImg.src = '/assets/images/common/card/img_card_front_noimage.jpg';
      }
      playerImg.src = playerImgPath;
      playerImg.alt = rowData.name;

      fragment.appendChild(cloneOddsListitem);
    });

    if (r.isDiscontinuation) {
      (() => {
        const addSelectorElement = oddsList.closest('.le-round-odds');
        addSelectorElement.classList.add('is-discontinuation');
        return r.isSp
          ? addSelectorElement
          : oddsList
      })().dataset.content = '中止';
    }

    // 作成した出走表の挿入
    oddsList.innerHTML = '';
    oddsList.appendChild(fragment);
    // スケルトン表示の解除
    oddsList.classList.remove('_skelton');
    oddsList.removeAttribute('aria-hidden');
  }

  // スタートポジションの作成
  const buildRefundStartPos = (data) => {
    const startPosRoot = document.querySelector('.le-round-start');

    if (data.length) {
      // スタートポジションの実際の並び順入れ替え、表示処理
      const startPosRow = startPosRoot.querySelector('.le-round-start-pos__row');
      const startPosRowList = startPosRow.firstElementChild;
      const startPosRowListItem = startPosRowList.firstElementChild;
      startPosRowListItem.classList.remove(...rowColors)

      const fragment = document.createDocumentFragment();
      data.forEach(bikeNo => {
        const cloneStartPosItem = startPosRowListItem.cloneNode(true);
        cloneStartPosItem.classList.add(rowColors[bikeNo - 1]);
        cloneStartPosItem.querySelector('.le-round-start-pos__row-num').textContent = bikeNo;
        fragment.appendChild(cloneStartPosItem);
      })

      startPosRowList.innerHTML = '';
      startPosRowList.appendChild(fragment);
      startPosRow.classList.remove('_skelton');
      startPosRow.removeAttribute('aria-hidden');
    } else {
      // データが無い場合は親要素から削除（レイアウトでマージン設定を行っているため）
      startPosRoot.parentElement.remove();
    }
  }

  // 出走取り消し時のオーバーレイ要素作成
  const createCancelCell = () => {
    const cell = document.createElement('div');
    cell.classList.add('le-round-odds__body-cell', '_cancel')
    cell.textContent = `取消`;
    return cell;
  }

  // 注意事項の表示処理
  const buildRunNote = (noteText) => {
    const note = document.querySelector('.le-round-race__note');
    if (noteText) {
      note.querySelector('.le-round-race__note-txt').textContent = noteText;

      note.classList.remove('_skelton');
      note.removeAttribute('aria-hidden');
    } else {
      note.remove();
    }
  }

  const hideRoundRaceHeader = () => {
    const raunTable = document.getElementById('run')
    const roundRaceHeader = raunTable.querySelector('.le-round-race__header');
    roundRaceHeader.classList.add('_compress');
  }

  init();
}
